export const CLASSNAMES = {
  modal: 'corva_modal',
};
